export type FieldTone = 'light' | 'dark'

export function inputClass(tone: FieldTone, hasError: boolean) {
  const base =
    'w-full rounded-input border px-4 text-[15px] outline-none transition-[border-color,box-shadow] duration-150 focus:ring-4'
  if (tone === 'dark') {
    return `${base} bg-white/[0.05] text-white placeholder:text-white/40 focus:border-afb-turquoise focus:ring-afb-turquoise/20 ${
      hasError ? 'border-red-400' : 'border-white/15 hover:border-white/30'
    }`
  }
  return `${base} bg-white text-afb-ink placeholder:text-afb-muted/70 focus:border-afb-teal focus:ring-afb-turquoise/25 ${
    hasError ? 'border-red-600' : 'border-afb-line hover:border-afb-ink/25'
  }`
}

export function labelClass(tone: FieldTone) {
  return `mb-1.5 block text-sm font-medium ${tone === 'dark' ? 'text-white/80' : 'text-afb-ink'}`
}

export function errorClass(tone: FieldTone) {
  return `mt-1.5 text-sm ${tone === 'dark' ? 'text-red-300' : 'text-red-700'}`
}
